export const SET_NO_ONE_ON_CALL_OPEN = 'SET_NO_ONE_ON_CALL_OPEN';

export const GET_SHIFT_GAPS_FOR_GROUPS = 'GET_SHIFT_GAPS_FOR_GROUPS';
export const GET_SHIFT_GAPS_FOR_GROUPS_START =
  'GET_SHIFT_GAPS_FOR_GROUPS_START';
export const GET_SHIFT_GAPS_FOR_GROUPS_SUCCESS =
  'GET_SHIFT_GAPS_FOR_GROUPS_SUCCESS';
export const GET_SHIFT_GAPS_FOR_GROUPS_FAIL = 'GET_SHIFT_GAPS_FOR_GROUPS_FAIL';

export const setNoOneOnCallOpen = visible => ({
  type: SET_NO_ONE_ON_CALL_OPEN,
  payload: visible,
});

export const getShiftGapsForGroups = ({ groups, from, to, timezone }) => {
  if (window.XM_getShiftGapsForGroups) {
    window.XM_getShiftGapsForGroups(
      groups,
      from.unix().toString(),
      to.unix().toString(),
      timezone,
    );

    return { type: GET_SHIFT_GAPS_FOR_GROUPS_START };
  }

  return { type: GET_SHIFT_GAPS_FOR_GROUPS_FAIL };
};
